<script setup lang="ts">
defineOptions({ inheritAttrs: false });

import { ref } from "vue";
import { useFormItemValidate, useFormValidate } from "@/hooks";

const props = defineProps<{
  buttonText?: string;
  formKeys: string[];
  formItemKeys: string[];
  duration: number;
}>();

const emit = defineEmits(["click"]);

const { validate } = useFormValidate(props.formKeys);
const { validate: validateItem } = useFormItemValidate(props.formItemKeys);

const count = ref(0);
const timerId = ref();

async function onClick(e: any) {
  if (validate) {
    const isValid = await validate();
    if (!isValid) return;
  }

  if (validateItem) {
    const isValid = await validateItem();
    if (!isValid) return;
  }

  count.value = props.duration;
  timerId.value = setInterval(function () {
    count.value = count.value - 1;
    if (count.value === 0) {
      clearInterval(timerId.value);
      timerId.value = undefined;
    }
  }, 1000);

  emit("click", e);
}
</script>
<template>
  <nut-button
    class="mp-timing-button"
    v-bind="$attrs"
    :disabled="count > 0"
    @click="onClick"
  >
    <template #default>
      <span v-if="count > 0">{{ count }}秒</span>
      <span v-else>{{ buttonText }}</span>
    </template>
    <template #icon v-if="$slots.icon">
      <slot name="icon" />
    </template>
  </nut-button>
</template>
<style lang="scss">
.mp-timing-button.nut-button--square {
  &.nut-button--mini {
    border-radius: 6px !important;
  }

  &.nut-button--small {
    border-radius: 8px !important;
  }

  &.nut-button--normal {
    border-radius: 10px !important;
  }

  &.nut-button--large {
    border-radius: 12px !important;
  }
}
</style>
